import { NgModule } from '@angular/core';
import { RemoveBehaviorIDTokenPipe } from './remove-behavior-id-token.pipe';

@NgModule({
    imports: [RemoveBehaviorIDTokenPipe],
    exports: [RemoveBehaviorIDTokenPipe],
})
export class RemoveBehaviorIdTokenPipeModule {}
